/**
 * @generated SignedSource<<90e3af1a754aee17ba8ba84ca8ddf53f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserDeetsInput = {
  clientMutationId?: string | null | undefined;
  userDeets?: ReadonlyArray<UpdateUserDeetsRecordInput | null | undefined> | null | undefined;
};
export type UpdateUserDeetsRecordInput = {
  deetId?: any | null | undefined;
  other?: string | null | undefined;
};
export type useUserDeetsMutation$variables = {
  input: UpdateUserDeetsInput;
};
export type useUserDeetsMutation$data = {
  readonly updateUserDeets: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useUserDeets_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useUserDeetsMutation = {
  response: useUserDeetsMutation$data;
  variables: useUserDeetsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserDeetsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserDeetsPayload",
        "kind": "LinkedField",
        "name": "updateUserDeets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useUserDeets_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUserDeetsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserDeetsPayload",
        "kind": "LinkedField",
        "name": "updateUserDeets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "DEET_BY_DEET_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "UserDeetConnection",
                    "kind": "LinkedField",
                    "name": "userDeets",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserDeet",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deetId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "other",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userDeets(orderBy:[\"DEET_BY_DEET_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "40d7e5e3ccd951bfb8d39b87682ba570",
    "id": null,
    "metadata": {},
    "name": "useUserDeetsMutation",
    "operationKind": "mutation",
    "text": "mutation useUserDeetsMutation(\n  $input: UpdateUserDeetsInput!\n) {\n  updateUserDeets(input: $input) {\n    query {\n      ...useUserDeets_query\n      id\n    }\n  }\n}\n\nfragment useUserDeets_query on Query {\n  currentUser {\n    userDeets(orderBy: [DEET_BY_DEET_ID__SEQUENCE_ASC]) {\n      nodes {\n        deetId\n        other\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b77960f3bddd4f17cc85ea8be001b96f";

export default node;
